import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {
  panelOpenState = {};
  faqList = [];
  featureTags = {};
  private destroy$ = new Subject<void>();
  private readonly isBrowser;

  constructor(private apiService: ApiService, private sanitizer: DomSanitizer, private activate: ActivatedRoute,
    public router: Router, private notificationService: NotificationService, @Inject(PLATFORM_ID) private platformId: Object,
    public sharedDataService: SharedDataService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    if(!!this.featureTags && this.featureTags['sf_faq_content']){
      if (this.isBrowser) {
        this.GetCMSPages();
      }
    }else if(!!this.featureTags && !this.featureTags['sf_faq_content']){
      this.GetCMSPages();
    }

    if(!!this.featureTags && this.featureTags['sf_header_cart_count']){
      this.sharedDataService.cartResponse$.pipe(
        takeUntil(this.destroy$)
      ).subscribe(res => {        
        this.getCartCount();
      });      
    }
  }
  isExpShow(e, ind) {
    e ? this.panelOpenState[ind] = true : this.panelOpenState[ind] = false;
  }
  GetCMSPages() {
    let storeId = JSON.parse(sessionStorage.getItem('store')).id;
    this.apiService.getContentItems({ type: 'faq', store_id: storeId })
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.apiService.SetCmsPage(result['response']['data']);
        if (result['response']['data'].length > 0) {
          const Htmlcontent = result['response']['data'];
          this.faqList = Htmlcontent;
        }
      }
    });
  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      this.sharedDataService.getOrderData();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
